// Based on lodash 5.0.0 (2023-10-25)

import { REGEX_OBJECTHELPER_UNESCAPE, REGEX_OBJECTHELPER_PROP_NAME } from '../constants/regex';

export class ObjectHelper {

	public get(object: Record<PropertyKey, any>, path: string | string[]) {
		const cast = this.castPath(path);
		const { length } = cast;
		let index = 0;
		let reference: any = object;

		while (index < length) {
			const part = cast[index];
			if (!Object.hasOwn(reference, part)) break;
			if (index + 1 === length) return reference[part];
			reference = reference[part];
			index += 1;
		}
	}

	public set(object: Record<PropertyKey, any>, path: string | string[], value: any) {
		const cast = this.castPath(path);
		const { length } = cast;
		let index = 0;
		let reference: any = object;

		while (index < length) {
			const part = cast[index];

			if (!Object.hasOwn(reference, part)) {
				reference[part] = this.isNumeric(cast[index + 1]) ? [] : {};
			}

			if (index + 1 === length) reference[part] = value;

			reference = reference[part];
			index += 1;
		}
	}

	public has(object: Record<PropertyKey, any>, path: string | string[]) {
		let reference: any = object;

		return this.castPath(path).every(part => {
			if (!Object.hasOwn(reference, part)) return false;
			reference = reference[part];
			return true;
		});
	}

	public unset(object: Record<PropertyKey, any>, path: string | string[]) {
		const cast = this.castPath(path).slice(0, -1);
		const { length } = cast;
		let index = 0;
		let reference: any = object;

		while (index < length) {
			const part = cast[index];
			if (!Object.hasOwn(reference, part)) break;
			if (index + 1 === length) delete reference[part];
			reference = reference[part];
			index += 1;
		}

		return true;
	}

	private castPath(path: string | string[]) {
		return Array.isArray(path)
			? path
			: this.stringToPath(path);
	}

	private stringToPath(string: string) {
		const result: string[] = [];

		if (string.charAt(0) === '.') {
			result.push('');
		}

		string.replace(REGEX_OBJECTHELPER_PROP_NAME, (match, expression, quote, subString) => {
			let key = match;

			if (quote && typeof subString === 'string') {
				key = subString.replace(REGEX_OBJECTHELPER_UNESCAPE, '$1');
			} else if (expression) {
				key = (expression as string).trim();
			}

			result.push(key);

			return '';
		});

		return result;
	}

	private isNumeric(object: unknown): object is number | `${number}` {
		if (typeof object === 'object' || object === undefined) return false;
		const parsed = Number.parseFloat(String(object));
		return !Number.isNaN(parsed) && Number.isFinite(parsed);
	}
}
